export function sourcePageLabel(source) {
  const page = String((source && source.page) || '').trim();
  return page.toLowerCase() === 'projects' ? 'Builds' : page;
}

function projectEntryId(source) {
  if (source && source.entity && source.entity.kind === 'project' && source.entity.id) {
    return String(source.entity.id);
  }
  const sourceId = String((source && source.source_id) || '');
  return sourceId.startsWith('projects:') ? sourceId.slice('projects:'.length) : '';
}

// These pages are served directly and do not belong to the hash router.
const DOCUMENT_PATHS = new Set([
  '/slidepoise', '/slidepoise/', '/slidepoise/index.html',
  '/slidepoise/docs/site', '/slidepoise/docs/site/', '/slidepoise/docs/site/index.html',
]);

export function viewSourceTarget(source) {
  if (!source || !source.route) return null;

  const page = sourcePageLabel(source).toLowerCase();
  const entryId = projectEntryId(source);
  if (entryId && page === 'builds') {
    return { path: '/projects', query: { to: entryId } };
  }

  return sourceRouteTarget(source.route, source.anchor);
}

export function sourceRouteTarget(route, anchor) {
  if (!route) return null;
  if (/^https?:\/\//.test(route)) {
    const url = new URL(route);
    if (anchor) url.hash = anchor;
    return { href: url.href };
  }
  const documentPath = String(route).split(/[?#]/, 1)[0];
  if (DOCUMENT_PATHS.has(documentPath)) {
    const documentUrl = new URL(route, 'https://source.invalid');
    documentUrl.pathname = '/slidepoise/';
    if (anchor) documentUrl.hash = anchor;
    return { href: `${documentUrl.pathname}${documentUrl.search}${documentUrl.hash}` };
  }

  const target = { path: route };
  if (anchor) target.hash = `#${anchor}`;
  return target;
}

// Search and project entry links open the published project website. Source
// records and saved View citations retain their original personal-site URLs.
export function projectWebsiteTarget(route, anchor) {
  const target = sourceRouteTarget(route, anchor);
  if (target?.href && !/^https?:\/\//.test(route)) {
    const url = new URL(target.href, 'https://slidepoise.github.io');
    url.pathname = '/';
    return { href: url.href };
  }
  return target;
}
